let nodeIdInit = 0;
const NODE_KEY = 'id';
const markNodeData = (node, data) => {
  if (!data || data[NODE_KEY]) return;
  Object.defineProperty(data, NODE_KEY, {
    value: node[NODE_KEY],
    enumerable: false,
    configurable: false,
    writable: false,
  });
};
const arrayFindIndex = (arr, pred) => {
  for (let i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

class Node {
  constructor(options) {
    this[NODE_KEY] = nodeIdInit++;
    this.isCurrent = false;
    this.isContexting = false;
    this.expanded = false;
    this.checked = false;
    this.indeterminate = false;
    this.parent = null;
    this.data = null;

    const keys = Object.keys(options);
    keys.forEach(name => {
      if (Object.prototype.hasOwnProperty.call(options, name)) {
        this[name] = options[name];
      }
    });

    if (options.data && Object.prototype.toString.call(options.data) === '[object Object]') {
      const dataKeys = Object.keys(options.data);
      dataKeys.forEach(name => {
        if (Object.prototype.hasOwnProperty.call(options.data, name)) {
          this[name] = options.data[name];
        }
      });
    }

    this.level = 0;
    this.childNodes = [];

    if (this.store.nodeKey) {
      this[NODE_KEY] = options[this.store.nodeKey];
    }

    if (this.store.lazy) {
      this.loading = false;
      this.loaded = false;
      this.hasMore = false;
    } else {
      this.isLeaf = !this.children;
      this.setData(this.data, true);
      if (this.store.expandAll) {
        this.expanded = true;
      }
    }

    if (this.parent) {
      this.level = this.parent.level + 1;
      this[`parent_${NODE_KEY}`] = this.parent[NODE_KEY];
    }

    if (!Array.isArray(this.data)) {
      markNodeData(this, this.data);
    }

    this.store.addNode(this);
  }

  setData(data, init) {
    this.data = data;
    this.childNodes = [];
    let children = [];
    if (this.level === 0 && this.data instanceof Array) {
      children = this.data;
    } else {
      children = this.children || [];
    }
    children && children.forEach(item => {
      this.insertChild({ data: item }, undefined, init);
    });
  }

  insertChild(child, index, init) {
    if (!(child instanceof Node)) {
      if (!init) {
        const children = this.getChildren(true);
        if (typeof index === 'undefined' || index < 0) {
          children.push(child.data);
        } else {
          children.splice(index, 0, child.data);
        }
      }
      child = {
        ...child,
        parent: this,
        store: this.store,
      };
      child = new Node(child);
    }
    child.level = this.level + 1;
    if (typeof index === 'undefined' || index < 0) {
      this.childNodes.push(child);
    } else {
      this.childNodes.splice(index, 0, child);
    }
  }

  initChildren(data) {
    data.forEach(item => {
      this.insertChild({ data: item }, undefined, true);
    });
  }

  remove() {
    const { parent } = this;
    if (parent) {
      parent.removeChild(this);
    }
  }

  removeChild(child) {
    const index = this.childNodes.indexOf(child);
    if (index > -1) {
      this.store && this.store.deleteNode(child);
      child.parent = null;
      this.childNodes.splice(index, 1);
    }
  }

  removeChildByData(data) {
    let targetNode = null;

    for (let i = 0; i < this.childNodes.length; i++) {
      if (this.childNodes[i].data === data) {
        targetNode = this.childNodes[i];
        break;
      }
    }

    if (targetNode) {
      this.removeChild(targetNode);
    }
  }

  // setNode() {
  //   console.log(this.parent.childNodes.indexOf(this));
  // }

  setChecked(val, deep = true) {
    this.checked = val === true;
    this.indeterminate = val === 'half';
    if (this.childNodes && this.childNodes.length > 0) {
      const loopChildren = nodes => {
        nodes.forEach(node => {
          node.checked = val === true;
          node.indeterminate = val === 'half';
          if (node.childNodes && node.childNodes.length > 0 && deep) {
            loopChildren(node.childNodes);
          }
        });
      };
      loopChildren(this.childNodes);
    }
    if (this.parent.level !== 0 && !this.parent.isLeaf) {
      const loopParents = parent => {
        const checkedAll = parent.childNodes.every(node => node.checked === true);
        const checkedHalf = parent.childNodes.some(node => node.checked === true)
          && parent.childNodes.some(node => node.checked === false);
        parent.checked = checkedAll;
        parent.indeterminate = checkedHalf;
        if (parent.parent.level !== 0 && !parent.parent.isLeaf) {
          loopParents(parent.parent);
        }
      };
      loopParents(this.parent);
    }
  }

  getChildren() {
    if (this.level === 0) {
      return this.data;
    }

    const { data } = this;

    if (!data.children) {
      this.data = {
        ...data,
        children: [],
      };
    }
    return this.data.children;
  }

  updateChildren() {
    const newData = this.getChildren() || [];
    const oldData = this.childNodes.map(node => node.data);

    const newDataMap = {};
    const newNodes = [];

    newData.forEach((item, index) => {
      const key = item[NODE_KEY];
      const isNodeExists = !!key && arrayFindIndex(oldData, data => data[NODE_KEY] === key) >= 0;
      if (isNodeExists) {
        newDataMap[key] = { index, data: item };
      } else {
        newNodes.push({ index, data: item });
      }
    });

    if (!this.store.lazy) {
      oldData.forEach(item => {
        if (!newDataMap[item[NODE_KEY]]) this.removeChildByData(item);
      });
    }
    newNodes.forEach(({ index, data }) => {
      this.insertChild({ data }, index, true);
    });
  }

  getParents() {
    let { parent } = this;
    const parents = [];
    while (parent.level !== 0) {
      parents.push(parent.data.label);
      parent = parent.parent;
    }
    return parents.reverse();
  }
}
export default Node;
